import type { Components } from '@mui/material/styles';

export default function MUITableBody(): Components['MuiTableBody'] {
  return {};
}
